import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Typography } from '@material-ui/core'
import clsx from 'clsx'
import { TYPE_POLL } from 'app/constants/messageType'

const PRIMARY = 'primary'
const SECONDDARY = 'secondary'
const WARNING = 'warning'
const ERROR = 'error'
const INFO = 'info'

const renderBadge = (theme, variant) => {
  switch (variant) {
    case PRIMARY:
      return theme.palette.primary.main
    case SECONDDARY:
      return theme.palette.secondary.main
    case WARNING:
      return theme.palette.warning.main
    case ERROR:
      return theme.palette.error.main
    case INFO:
      return theme.palette.info.main
    default:
      break
  }
}

const useStyles = makeStyles((theme) => ({
  label: {
    fontSize: '10px',
    color: '#fff',
  },
  button: ({ variant }) => ({
    backgroundColor: renderBadge(theme, variant),
    borderRadius: 4,
  }),
}))

const NotificationBadge = ({
  className,
  variant = 'primary',
  Icon,
  isTextUpperCase = true,
  children,
  type,
}) => {
  const classes = useStyles({ variant })
  const isPoll = type === TYPE_POLL
  return (
    <span
      className={clsx(
        classes.button,
        isPoll ? 'flex px-6  cursor-default' : 'flex px-6 py-1 cursor-default',
        className,
      )}
    >
      {isPoll ? Icon : <div className="h-16 w-16">{Icon}</div>}

      <Typography
        className={clsx(
          classes.label,
          isTextUpperCase ? 'uppercase' : undefined,
          isPoll
            ? 'ltr:mr-4 rtl:ml-4 flex items-center px-3 align-baseline'
            : 'ltr:mr-4 rtl:ml-4 flex items-end align-baseline',
        )}
      >
        {children}
      </Typography>
    </span>
  )
}

export default NotificationBadge
